// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-schemas
import { format } from 'date-fns/format'
import { sub } from 'date-fns/sub'
import * as z from 'zod'

import * as constants from '@nxt-insurance/constants'

// This is the base schema that can be extended when using it in configs
export const BaseSchema_PetHealthV1LukoToGetsafeDe = z.object({
  neutered: z.boolean().optional(),
  pet_name: z.string().min(1).optional(),
  pet_type: z.enum(['dog', 'cat']),
  breed_type: z.string().min(1).optional(),
  pet_gender: z.enum(['male', 'female']).optional(),
  pet_born_on: z
    .union([z.number(), z.string(), z.date()])
    .pipe(
      z.coerce
        .date()

        .max(sub(new Date(), { weeks: 8 }))
    )
    .transform((value) => {
      return format(value, constants.SERVER_DATE_FORMAT)
    }),
  tariff_type: z.enum(['surgery', 'full_coverage']),
  breed_category: z.enum(['A', 'B', 'C', 'D', 'E']).optional(),
  pet_chip_number: z.string().optional(),
  surgery_tariff_line: z
    .enum(['surgery_cost_comfort_plus', 'surgery_cost_plus_premium'])
    .optional(),
  deductible_percentage: z.coerce
    .string()
    .pipe(z.enum(['30', '20', '0']))
    .pipe(z.coerce.number()),
  contract_holder_born_on: z
    .union([z.number(), z.string(), z.date()])
    .pipe(z.coerce.date())
    .nullish()
    .transform((value) => {
      if (value === undefined || value === null) {
        return value
      }
      return format(value, constants.SERVER_DATE_FORMAT)
    })
    .optional(),
  full_coverage_tariff_line: z
    .enum([
      'pet_health_comfort_plus',
      'pet_health_plus_premium',
      'pet_health_plus_premium_plus_dental',
      'pet_health_plus_premium_plus_dental_plus_best',
    ])
    .optional(),
  pet_previous_illness_type: z.string().min(1).optional(),
  pet_had_previous_illnesses: z.boolean().optional(),
  cancelled_by_previous_insurer: z.boolean().optional(),
})

const Schema_PetHealthV1LukoToGetsafeDe = BaseSchema_PetHealthV1LukoToGetsafeDe.superRefine(
  (values, ctx) => {
    if (values['pet_type'] !== undefined && ['dog'].includes(values['pet_type'])) {
      if (values['breed_type'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'string',
          received: 'undefined',
          message: 'Required',
          path: ['breed_type'],
        })
      }
    }
  }
)
  .superRefine((values, ctx) => {
    if (values['pet_type'] !== undefined && ['dog'].includes(values['pet_type'])) {
      if (values['breed_category'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'string',
          received: 'undefined',
          message: 'Required',
          path: ['breed_category'],
        })
      }
    }
  })
  .superRefine((values, ctx) => {
    if (values['tariff_type'] !== undefined && ['surgery'].includes(values['tariff_type'])) {
      if (values['surgery_tariff_line'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'string',
          received: 'undefined',
          message: 'Required',
          path: ['surgery_tariff_line'],
        })
      }
    }
  })
  .superRefine((values, ctx) => {
    if (values['tariff_type'] !== undefined && ['full_coverage'].includes(values['tariff_type'])) {
      if (values['full_coverage_tariff_line'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'string',
          received: 'undefined',
          message: 'Required',
          path: ['full_coverage_tariff_line'],
        })
      }
    }
  })
  .superRefine((values, ctx) => {
    if (
      values['pet_had_previous_illnesses'] !== undefined &&
      [true].includes(values['pet_had_previous_illnesses'])
    ) {
      if (values['pet_previous_illness_type'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'string',
          received: 'undefined',
          message: 'Required',
          path: ['pet_previous_illness_type'],
        })
      }
    }
  })

export default Schema_PetHealthV1LukoToGetsafeDe
